import { useTranslation } from 'react-i18next';

import { useNavigation } from '@react-navigation/native';

import { useAlerts } from '@/feature/alerts/hooks/use-alerts';
import { useActiveProductName } from '@/hooks/use-active-product-name';

export const useAgeCohortValidation = () => {
    const { showInfoSheet } = useAlerts();
    const { t } = useTranslation(['common', 'age_cohort', 'kyc', 'transactions']);
    const activeProduct = useActiveProductName();
    const navigation = useNavigation();

    const showAgeRestrictionNotice = () => {
        showInfoSheet({
            title: t('age_cohort:age_restriction_title'),
            description: t('age_cohort:age_restriction_details'),
            buttonLabel: t('common:close'),
        });
    };

    const showDepositAgeRestrictionNotice = () => {
        showInfoSheet({
            title: t('kyc:before_you_deposit'),
            description: t('age_cohort:age_restriction_deposit_details'),
            buttonLabel: t('transactions:deposit_to_product', {
                product: activeProduct,
            }),
            secondaryLabel: t('close'),
            handlePress: () => {
                navigation.navigate('DepositScreen', {
                    selectedAmount: '',
                });
            },
        });
    };

    return { showAgeRestrictionNotice, showDepositAgeRestrictionNotice };
};
